import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {searchActions, searchSelectors} from "../../store/search";
import {authSelectors} from "../../store/auth";
import styled from 'styled-components'
import {withFirebase} from "../../components/Firebase";
import {Backdrop, Block, Input, Overlay, Portal, Tabs} from "reakit";
import {Box, Button, Card, Flex, Heading, Text} from 'rebass';
import {DesktopBox, MobileBox, PositionBox, TabHeader, Toolbar} from "../../components/Base";
import BasicSearch from '../../components/Forms/BasicSearch'
import UserList from '../../components/UserList'
import IosArrowDown from 'react-ionicons/lib/IosArrowDown'
import {ActiveCheckin, ActiveLog, InactiveCheckin, InactiveLog} from "../../components/Base/Icons";
import ConfirmDiscardCheckin from '../../components/Modals/ConfirmDiscardCheckin'
import ConfirmDeleteCheckin from '../../components/Modals/ConfirmDeleteCheckin'

import ApplyFilters from '../../components/Search/ApplyFilters'
import FilterDropdown from '../../components/Search/FilterDropdown'
import Truncate from 'react-truncate';

import {filterSearchResults, filterStudentsByName, getTimeStamp, returnFilterString, returnWithRosterFilterString} from "../../utils"; 
import {schoolSelectors} from "../../store/school";
// import {searchSelectors} from "../../store/search";

import { uniq } from 'lodash-es';

const FilterOverlay = styled(Overlay)`
width: 100%;
height: 100%;
`;

let ClickTimeout=null;
/* icon imports */
const Wrapper = styled(Card)`

min-width: 250px;
  	height: calc(100vh - 240px);
   overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  @media(max-width: 700px){
  	//height: calc(100vh - 185px);

  }
`;

Wrapper.defaultProps = {
	pt: '40px',
	pb: ['100px']
};

const HeaderWrapper = styled(Card)`
position: relative;
top: 0;
left: 0;
width: 100%;
height: 240px;
@media(max-width: 700px){
  	height: calc(100% - 45px);

  }
//max-height: 163px;
`

const LogHeaderWrapper = styled(Card)`
position: relative;
top: 0;
left: 0;
width: 100vw;
height: 140px;
@media(max-width: 700px){
  	height: 140px;

  }
//max-height: 163px;
`

HeaderWrapper.defaultProps = {
	p: [2],
	boxShadow: 'main'
};

LogHeaderWrapper.defaultProps = {
	p: [2],
	boxShadow: 'main'
};

const INITIAL_STATE = {
	selected: [],
	isPrevious: false,
	searchTerm: '',
	showLog: false,
	logInput: '',
	dutyLog: null,
	live: false,
	active: true,
	previousID: null,
	previous: null,
	inputFocus: false,
	// newFilter: null,
	showDiscardPopup: false
};

class Checkin extends Component {

	state = {
		selected: [],
		isPrevious: false,
		searchTerm: '',
		showLog: false,
		logInput: '',
		dutyLog: null,
		live: false,
		active: true,
		previousID: null,
		previous: null,
		inputFocus: false,
		showDiscardPopup: false,
		showDeletePopup: false,
		newFilters: null,
		newIdList: [],
		filters: {
			grade: [],
			location: [],
			dorm: [],
			gender: [],
			type: []
		},
		mainFilters: {
			grade: [],
			location: [],
			dorm: [],
			gender: [],
			type: []
		},
		newRosterFilters: []
	};


	// On mount, save current checkin filters to state
	// if previous checkin - SearchFilters  else save checkin filters,
	componentDidMount() {
		const {previous, students, searchFilters, searchRosterFilters, filters} = this.props;
		if (previous !== null) {
			this.setState({
				previous,
				selected: previous.present,
				isPrevious: true,
				logInput: previous.duty_log || '',
				live: previous.live,
				previousID: previous.id,
				active: previous.active,
				mainFilters: filters,
				newRosterFilters: previous.rosterFilter
			})
			// if(previous.live){
			// 	updateFilter(previous.filters)
			this.listener = this.returnLiveListener(previous.id)
			// }
		} else {
			const filteredIdList = students.map(student => student.id)

			this.setState({
				newFilters: searchFilters, 
				newIdList: filteredIdList, 
				mainFilters: searchFilters,
				newRosterFilters: searchRosterFilters
			})
		}
		// clearFilter()

	}


	returnLiveListener = (id) => {
		return this.props.firebase.checkin(id).onSnapshot(snapshot => {
			const result = {id: snapshot.id, ...snapshot.data()}
			this.setState({
				selected: result.present,
				previous: result,
				dutyLog: result.duty_log,
				live: result.live,
				active: result.active
			})
		})
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.state.inputFocus === false && this.state.dutyLog !== null && this.state.dutyLog !== this.state.logInput) {
			this.setState({logInput: this.state.dutyLog})
		}

	}

	handleSelect = (details, event) => {
		if (ClickTimeout !== null) {
			clearTimeout(ClickTimeout);
			ClickTimeout = null;
			this.handleDoubleClick(details);
		} else {
			ClickTimeout = setTimeout(() => {
				clearTimeout(ClickTimeout);
				ClickTimeout = null;
				this.handleSingleClick(details);
			}, 300)
		}
	};

	handleDoubleClick = async (details) => {
		await this.handleSave();
		await this.props.handleSelectStudent(details, true, this.state.selected);
	};

	handleSingleClick = (details) => {
		let {selected, previousID} = this.state;
		let contains = false;
		if (selected) {
			for (var i = selected.length - 1; i >= 0; i--) {
				if (selected[i] === details.id) {
					selected.splice(i, 1);
					contains = true;
					this.setState({selected})
					// break;       //<-- Uncomment  if only the first term has to be removed
				}
			}
			if (!contains) {
				selected.push(details.id);
				this.setState({selected})
			}
			if (previousID) {
				this.handleUpdateCheckin(selected)
			}
		}
	} 

	handleLogInput = async (e) => {
		let {selected, previousID} = this.state;

		this.setState({logInput: e.target.value})
		if (previousID) await this.handleUpdateCheckin(selected)
	}

	handleSearchInput = (e) => {
		this.setState({searchTerm: e.target.value})
	}

	handleSave = async () => {
		const {selected, logInput, previousID, newFilters, newIdList, newRosterFilters} = this.state;
		const {handleSave, toggleVisible, firebase, clearFilter, clearRosterFilter} = this.props;
		try{
			if (previousID === null) {
				// const prevFilters = filters
				// updateFilter(newFilters)
				const newID = await handleSave(selected, logInput, newIdList);
				let checkinRef = firebase.checkin(newID)
				// updateFilter(prevFilters)
				// update with filters saved on mount after initial save ONLY
				checkinRef.update({
					filters: newFilters,
					rosterFilter: newRosterFilters
					// all: newIdList
				})
			} else {
				await this.handleUpdateCheckin(selected)
			}
		} catch(err) {
			console.log(err)
		}
		
		clearFilter()
		clearRosterFilter();
		toggleVisible()
	};

	handleToggleLiveCheckin = async () => {
		const {selected, logInput, previousID, isPrevious, live, newFilters, newRosterFilters, newIdList} = this.state;
		const {handleSave, firebase} = this.props;


		if (!isPrevious) {
			// let prevFilters = filters
			// // updateFilter(newFilters)
			const newID = await handleSave(selected, logInput, newIdList);

			// updateFilter(prevFilters)
			let checkinRef = firebase.checkin(newID)
			checkinRef.update({
				live: !live,
				updated_at: getTimeStamp(),
				filters: newFilters,
				rosterFilter: newRosterFilters
			})

			const newCheckinRef = await checkinRef.get()
			const checkin = {id: newCheckinRef.id, ...newCheckinRef.data()}
			this.setState({live: !live, previousID: newID, previous: checkin, isPrevious: true})
			this.listener = this.returnLiveListener(newID)
		} else {
			try {

				let checkinRef = firebase.checkin(previousID)
				checkinRef.update({
					live: !live,
					updated_at: getTimeStamp()
				})
				if (live === true) {
					this.listener()
				} else {
					this.listener = this.returnLiveListener(previousID)
				}
				this.setState({live: !live})

			} catch (err) {
				console.log('failed to update checkin', err)
			}
		}
	}

	handleUpdateCheckin = async (selected) => {
		const {firebase} = this.props;

		const {previousID, logInput} = this.state;
		try {
			let checkinRef = firebase.checkins().doc(previousID);


			checkinRef.update({
				present: selected,
				duty_log: logInput,
				updated_at: getTimeStamp()
			});

		} catch (e) {
			console.log("Error saving checkin: ", e)
		}
	}

	toggleDiscardPopup = () => {
		const {showDiscardPopup} = this.state;
		this.setState({showDiscardPopup: !showDiscardPopup})
	}

	toggleDeletePopup = () => {
		const {showDeletePopup} = this.state;
		this.setState({showDeletePopup: !showDeletePopup})
	}

	handleDiscard = async () => {
		const {selected, logInput, previousID, newIdList} = this.state;

		const {handleDiscard, toggleVisible, handleSave, clearFilter, clearRosterFilter} = this.props;

		const {isPrevious} = this.state;
		if (isPrevious === false) { 
			const newId = await handleSave(selected, logInput, newIdList)
			this.handleMakeInactive(newId)

		} else {
			// this.setState({selected: []});
			await this.handleUpdateCheckin(selected, logInput)
			// console.log('saveresult', saveResult)
			this.handleMakeInactive(previousID)

		}
		// this.setState(INITIAL_STATE)
		handleDiscard()
		clearFilter()
		clearRosterFilter();
		toggleVisible()
	};

	handleMakeInactive = (previousID) => {
		const {firebase} = this.props;

		try {
			let checkinRef = firebase.checkins().doc(previousID);
			checkinRef.update({
				active: false,
				updated_at: Math.floor(Date.now() / 1000)
			})
		} catch (e) {
			console.log("Error saving checkin: ", e)
		}
	}

	handleDeleteCheckin = () => {
		const {previousID} = this.state;
		const {firebase, toggleVisible, handleDiscard, clearFilter, clearRosterFilter} = this.props;
		if (previousID !== null) {
			try {
				let checkinRef = firebase.checkins().doc(previousID);
				checkinRef.delete()
			} catch (e) {
				console.log("Error saving checkin: ", e)
			}
		}
		this.setState(INITIAL_STATE)

		handleDiscard()
		clearFilter()
		clearRosterFilter()
		toggleVisible()
	}


	componentWillUnmount() {
		this.listener && this.listener()
	}

	filterStudentList = () => {
		const {students, filters} = this.props;

		const {searchTerm, newFilters} = this.state;
		let all = filterStudentsByName(students, searchTerm)
		if (newFilters) {
			all = filterSearchResults(newFilters, all)
		}
		all = filterSearchResults(filters, all)

		if (all === undefined || all === null) {
			all = []
		}
		return all
	}

	returnCheckinTitle = () => {
		const {loadingSchool, schoolInfo} = this.props;
		const {isPrevious, previous, mainFilters, newRosterFilters} = this.state;
		let {title} = this.props;
		
		if (!isPrevious && !loadingSchool) {
			title = returnWithRosterFilterString(newRosterFilters, returnFilterString(mainFilters, schoolInfo))
		}
		else if (previous && previous.filters && previous.type !== 1) {
			title = returnWithRosterFilterString(newRosterFilters, returnFilterString(previous.filters, schoolInfo))
		}
		else if (previous && previous.filters && previous.type === 1) {
			title = title + ', ' + returnWithRosterFilterString(newRosterFilters, returnFilterString(previous.filters, schoolInfo))
		}

		return title
	}

	returnFilterTitle = () => {
		// const {} = this.state;
		const {schoolInfo,filters, loadingSchool} = this.props;
		let filterTitle = 'All Students'
		if (!loadingSchool) {

			const title = this.returnCheckinTitle()
			filterTitle = returnFilterString(filters, schoolInfo)
			if (filterTitle !== 'All Students') {
				if (title !== 'All Students') {
					filterTitle = filterTitle + ', ' + title
				}
			} else {
				filterTitle = title
			}
		}
		return filterTitle
	}

	filteredByRoster = students => {
		const { rosterFilter } = this.props;
		const { newRosterFilters } = this.state;
		let newData = [];
		rosterFilter.forEach(obj => {
			newData.push(...obj.students_uid);
		});

		newRosterFilters.forEach(obj => {
			newData.push(...obj.students_uid);
		});

		let rosterStudentId = uniq(newData);
		
		if (rosterStudentId.length === 0) {
			return students
		} else {
			return students.filter(obj => rosterStudentId.includes(obj.id))
		}
	}

	render() {
		const {visible, profileInfo, toggleVisible, isFaculty} = this.props;
		const {selected, active, live, logInput, previousID, previous, inputFocus} = this.state;
		const title = this.returnCheckinTitle()
		let all;
		if (!isFaculty) {
			all = this.filterStudentList();
		}
		else {
			all = this.filteredByRoster(this.filterStudentList());
		}
		 

		let isOwner = false
		if (previous && profileInfo.id === previous.creator_uid) isOwner = true
		if (previousID === null) isOwner = true

		let showUserList = false
		if (selected) {
			showUserList = true
		}
		if (!isOwner && !live) {
			toggleVisible()
		}
		return (
			<Overlay.Container>
				{overlay => (
					<Block>
						<Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
						<FilterOverlay use={Portal} {...overlay} visible={visible} margin={0} padding={0}>

							<Tabs.Container>
								{tabs => (
									<Block>


										{/* Student Lists*/}
										<Tabs.Panel tab="first" {...tabs}>
											<Tabs.Container>
												{tabs => (
													<Block>
														<HeaderWrapper boxShadow={'main'} height={'165px'}>
															<Flex>
																<Box>
																	<Text onClick={this.handleSave}><IosArrowDown size={'30px'}/></Text>
																</Box>
																<Box ml={'auto'}/>
																{isOwner &&
																<Box>
																	{active ?
																		<Button disabled={!isOwner} onClick={this.toggleDiscardPopup} bg={'meta'}
																		        variant='checkin' p={2}>Discard</Button> :
																		<Button disabled={!isOwner} onClick={this.toggleDeletePopup} bg={'meta'}
																		        variant='checkin' p={2}>Delete</Button>
																	}
																</Box>}
															</Flex>
															<Box>
																<Flex flexDirection={'row'}>
																	<Heading pt={2}>Check In</Heading>

																	<Box pl={2}>
																		<Button variant={'checkin'} disabled={!isOwner} bg={live ? 'purple' : 'meta'}
																		        onClick={this.handleToggleLiveCheckin}>{live ? 'Live' : 'Private'}</Button>
																		<Text pt={1} textAlign='center' color={'meta'}
																		      fontSize={'8px'}>{live ? "Click to make private" : "Click to make live"}</Text>

																	</Box>

																</Flex>
																{this.renderFilterControl()}
																<Text ml={1} fontWeight={600} pt={[3, 0]} pb={2} color={'meta'} fontSize='21px'>
																	<Truncate
																		lines={1}
																	>
																		{title}

																	</Truncate>
																</Text>
															</Box>
															{/*{!showLog &&*/}
															{this.renderSearchToolbar()}
															<Tabs boxShadow={'none'}>
																<Tabs.Tab tab="all" {...tabs}><TabHeader title={'All'}/></Tabs.Tab>
																<Tabs.Tab tab="present" {...tabs}><TabHeader title={'Present'}/></Tabs.Tab>
																<Tabs.Tab tab="absent" {...tabs}><TabHeader title={'Absent'}/></Tabs.Tab>

															</Tabs>
														</HeaderWrapper>
														{/*{!showLog &&*/}
														<Box>
															<Tabs.Panel tab="all" {...tabs}>
																<Wrapper>
																	<UserList 
																		withLocation
																		students={all}
																		handleUserClick={this.handleSelect}
																		selected={selected}
																	/>
																</Wrapper></Tabs.Panel>
															<Tabs.Panel tab="present" {...tabs}>
																<Wrapper>
																	{showUserList &&
																	<UserList
																		withLocation
																		students={all.filter(student => selected.includes(student.id))}
																		handleUserClick={this.handleSelect} selected={selected}/>
																	}
																</Wrapper>
															</Tabs.Panel>
															<Tabs.Panel tab="absent" {...tabs}>
																<Wrapper>
																	{showUserList &&

																	<UserList
																		withLocation
																		students={all.filter(student => !selected.includes(student.id))}
																		handleUserClick={this.handleSelect}/>
																	}
																</Wrapper>
															</Tabs.Panel>
														</Box>
													</Block>
												)}
											</Tabs.Container>
										</Tabs.Panel>


										{/* Duty Log */}
										<Tabs.Panel tab="second" {...tabs}>
											<LogHeaderWrapper boxShadow={'main'}>
												<Flex>
													<Box>
														<Text onClick={this.handleSave}><IosArrowDown size={'30px'}/></Text>
													</Box>
													<Box ml={'auto'}/>
													<Box>
														{active && isOwner &&
														<Box>
															<Button onClick={this.toggleDiscardPopup} bg={'meta'} variant='checkin'
															        p={2}>Discard</Button>
														</Box>}
													</Box>
												</Flex>
												<Box>
													<Flex flexDirection={'row'}>
														<Heading pt={2}>Check In</Heading>
														{active &&
														<Box pl={2}>
															<Button variant={'checkin'} bg={live ? 'purple' : 'meta'}
															        onClick={this.handleToggleLiveCheckin}>{live ? 'Live' : 'Private'}</Button>
															<Text pt={1} textAlign='center' color={'meta'}
															      fontSize={'8px'}>{live ? "Click to make private" : "Click to make live"}</Text>

														</Box>}
													</Flex>
													<Text ml={1} fontWeight={600} pb={2} color={'meta'} fontSize='21px'>{title}</Text>
												</Box>

											</LogHeaderWrapper>


											{/* INPUT Area*/}
											<Card pt={3}>
												<Input name={'duty_log'} use={'textarea'} placeholder={'Type something in the duty log...'}
													   value={logInput} onChange={this.handleLogInput} height='70vh'
												       onFocus={() => this.setState({inputFocus: !inputFocus})}/>
											</Card>

										</Tabs.Panel>

										<Toolbar width={1} minHeight={'69px'} bg='gray' flexWrap='wrap' flexDiretion='row'
										         justifyContent='center'
										         position={['fixed']} bottom={0}>
											<Tabs>
												<Tabs.Tab tab="first" {...tabs}>
													{tabs.current !== 0 ? <InactiveCheckin/> : <ActiveCheckin/>}
												</Tabs.Tab>
												<Tabs.Tab tab="second" {...tabs}>
													{tabs.current !== 0 ? <ActiveLog/> : <InactiveLog/>}
												</Tabs.Tab>
											</Tabs>
										</Toolbar>
									</Block>
								)}
							</Tabs.Container>

							{isOwner &&
							<Fragment>
								{active ?
									this.renderDiscardPopup() : this.renderDeletePopup()}
							</Fragment>
							}

						</FilterOverlay>
					</Block>
				)}
			</Overlay.Container>
		)
	}

	renderSearchToolbar = () => {
		const {filters, clearFilter, schoolInfo, rosters, rosterFilter, history } = this.props;
		const {searchTerm, previous, newFilters, newRosterFilters} = this.state;
		const title = this.returnCheckinTitle()
		let checkinFilters;
		let checkinRosterFilter = [];
		if (previous) {
			checkinFilters = previous.filters
			checkinRosterFilter = previous.rosterFilter;
		} else {
			checkinFilters = newFilters
			checkinRosterFilter = newRosterFilters;
		}
		let filterTitle = returnFilterString(filters, schoolInfo)

		filterTitle = returnWithRosterFilterString(rosterFilter, filterTitle);

		if (filterTitle !== 'All Students') {
			if (title !== 'All Students' && title !== filterTitle ) {
				filterTitle = filterTitle + ', ' + title
			}

		} else {
			filterTitle = title
		}

		return (
			<Fragment>
				<DesktopBox>
					<Toolbar py={2} bg={'white'} boxShadow={['none']}>

						<Box css={{display: 'inline-block'}}><Text fontSize={0} fontWeight={700} py={2} mt={'3px'}
						                                           color={'meta'}>FILTER</Text></Box>
						<Box ml={3}>
							<FilterDropdown 
								school={schoolInfo} 
								filters={filters} 
								clearFilter={clearFilter} 
								isCheckin
								history={history}
								checkinFilters={checkinFilters} 
								title={filterTitle}
								rosters={rosters}
								checkinRosterFilter={checkinRosterFilter}
							/>
						</Box>


						<Box ml={'auto'}/>

						<Box width={1 / 2} pr={2}>
							<BasicSearch placeholder={'Search students...'} search={searchTerm} handleInput={this.handleSearchInput}/>

						</Box>
					</Toolbar>
				</DesktopBox>
				<MobileBox>
					<PositionBox position='fixed' left={0} top={'184px'} width={1} zIndex={1000}>
						<BasicSearch placeholder={'Search students...'} search={searchTerm} handleInput={this.handleSearchInput}/>
						{/*<ApplyFilters filters={filters} clearFilter={clearFilter} school={schoolInfo}/>*/}
					</PositionBox>
				</MobileBox>
			</Fragment>
		)
	}

	renderFilterControl = () => {
		const {previous, newFilters, newRosterFilters} = this.state;
		const {filters, clearFilter, schoolInfo, rosters, rosterFilter, history} = this.props;
		let checkinFilters;
		let checkinRosterFilter = [];
		if (previous) {
			checkinFilters = previous.filters
			checkinRosterFilter = previous.rosterFilter;
		} else {
			checkinFilters = newFilters
			checkinRosterFilter = newRosterFilters;
		}
		const title = this.returnCheckinTitle()

		let filterTitle = returnFilterString(filters, schoolInfo)

		filterTitle = returnWithRosterFilterString(rosterFilter, filterTitle);

		if (filterTitle !== 'All Students') {
			if (title !== 'All Students') {
				filterTitle = title + ', ' + filterTitle

			}

		} else {
			filterTitle = title
		}

		return (
			<MobileBox>
				<PositionBox position='relative' top={'0px'} pl={1}>
					<ApplyFilters 
						filters={filters} 
						clearFilter={clearFilter} 
						school={schoolInfo} 
						isCheckin
						checkinFilters={checkinFilters} 
						title={filterTitle}
						rosters={rosters}
						history={history}
						checkinRosterFilter={checkinRosterFilter}
					/>
				</PositionBox>
			</MobileBox>
		)
	}

	renderDiscardPopup = () => {
		const {showDiscardPopup} = this.state;

		return (
			<ConfirmDiscardCheckin visible={showDiscardPopup} toggle={this.toggleDiscardPopup}
			                       handleConfirm={this.handleDiscard} handleDelete={this.handleDeleteCheckin}/>
		)
	}

	renderDeletePopup = () => {
		const {showDeletePopup} = this.state;

		return (
			<ConfirmDeleteCheckin visible={showDeletePopup} toggle={this.toggleDeletePopup}
			                      handleConfirm={this.handleDeleteCheckin}/>
		)
	}


}

Checkin.propTypes = {
	previous: PropTypes.object
};

Checkin.defaultProps = {
	previous: null
};

const mapStateToProps = (state) => ({
	schoolInfo: schoolSelectors.refreshSchool(state.school),
	loadingSchool: schoolSelectors.isLoading(state.school),
	profileInfo: authSelectors.refreshProfile(state.auth),
	loading: authSelectors.isLoading(state.auth),
	filters: searchSelectors.refreshCheckinFilters(state.search),
	searchFilters: searchSelectors.refreshFilters(state.search),
	searchRosterFilters: searchSelectors.getRosterFilter(state.search),
	currentStudents: searchSelectors.refreshCheckinCurrentResults(state.search),
	rosterFilter: searchSelectors.getCheckinRosterFilter(state.search),
});

const mapDispatchToProps = dispatch => ({
	updateSearch: (term) => {
		dispatch(searchActions.updateSearch(term));
	},
	updateFilter: (filters) => {
		dispatch(searchActions.updateCheckinFilter(filters))
	},
	clearSearch: () => {
		dispatch(searchActions.clearSearch());
	},
	clearFilter: () => {
		dispatch(searchActions.clearCheckinFilter());
	},
	clearRosterFilter: () => {
		dispatch(searchActions.clearCheckinRosterFilter());
	},
	updateStudents: (students) => {
		dispatch(searchActions.updateStudents(students))
	},
	updatePlaceholder: (placeholder) => {
		dispatch(searchActions.updatePlaceholder(placeholder))
	},
	updateCheckinStudents: (students) => {
		dispatch(searchActions.updateCheckinStudents(students))
	},
});

export default withFirebase(connect(mapStateToProps, mapDispatchToProps)(Checkin))
